import useIcons from "@hooks/use-source-icons";
import { OneTileDynamicZoneModel } from "@models/strapi-components/tile-wrapper";
import React from "react";
import Title from "./Title";
export interface DemoCustomerTilesPropsModel {
  tiles: Partial<OneTileDynamicZoneModel>[];
  divColor?: string;
}
const DemoCustomerTiles: React.FC<DemoCustomerTilesPropsModel> = ({
  tiles,
  divColor,
}) => {
  const { getFromReactIcons } = useIcons();
  const renderTiles = () => {
    return tiles.map((tile) => {
      const { title, subTitle, icon = "", id } = tile;
      const Icon = getFromReactIcons(icon);
      return (
        <div
          key={id}
          className="flex justify-center text-black h-40 xl:h-auto mb-8 md:mb-0 xl:mb-0 w-full md:basis-full"
        >
          <div
            className="rounded-lg flex items-center justify-center p-5 pt-[38px] xl:pt-[50px] xl:px-8 xl:pb-8 text-center font-medium relative w-full"
            style={{ backgroundColor: tile.color }}
          >
            <div
              className="absolute p-4 border-[3px] rounded-full -top-8 flex items-center justify-center shadow-md border-white"
              style={{
                backgroundColor: tile.color,
              }}
            >
              {Icon && <Icon size={28} />}
            </div>
            <div>
              {title && (
                <Title variant="h3" titleText={title} className="text-center" />
              )}
              {subTitle && (
                <Title
                  variant="paragraph"
                  titleText={subTitle}
                  className="text-center"
                />
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <section>
      <div
        className="pt-[80px] pb-12 md:pt-[92px] md:pb-[60px] xl:pt-[112px] xl:pb-20 items-stretch"
        style={{
          backgroundColor: divColor ?? "#FFFFFF",
        }}
      >
        <div className="flex flex-col md:flex-row justify-center gap-12 w-[250px] md:w-[80%] lg:w-[70%] xl:w-[60%] mx-auto">
          {renderTiles()}
        </div>
      </div>
    </section>
  );
};

export default DemoCustomerTiles;
